//import Vue from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { isUserLoggedIn } from '@/services/authService'
import { getAppTitle } from '@/flavors'
import store from '@/store'

const routes = [
  {
    path: '/',
    name: 'signin',
    component: () => import(/* webpackChunkName: "about" */ '../components/login/SignIn.vue'),
    meta: { noAuthNeeded: true }
  },
  {
    path: '/sso',
    name: 'sso',
    component: () => import(/* webpackChunkName: "about" */ '../components/SSOPage.vue'),
    meta: { noAuthNeeded: true }
  },
  {
    path: '/refundpolicy',
    name: 'refundpolicy',
    component: () => import(/* webpackChunkName: "refundpolicy" */ '../components/login/RefundPolicy.vue'),
    meta: { noAuthNeeded: true }
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import(/* webpackChunkName: "signup" */ '../components/login/SignUp.vue'),
    meta: { noAuthNeeded: true }
  },
  {
    path: '/learn',
    name: 'learn',
    component: () => import(/* webpackChunkName: "about" */ '../components/learn/LearnPage.vue')
  },
  {
    path: '/myclasses',
    name: 'myclasses',
    component: () => import(/* webpackChunkName: "about" */ '../components/classes/MyClassesPage.vue')
  },
  {
    path: '/mynotifications',
    name: 'mynotifications',
    component: () => import(/* webpackChunkName: "about" */ '../components/notifications/MyNotificationsPage.vue')
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: () => import(/* webpackChunkName: "about" */ '../components/calendar/MyCalendar.vue')
  },
  {
    path: '/combinedreports',
    name: 'combinedReports',
    component: () => import(/* webpackChunkName: "about" */ '../components/combinedReports/CombinedReports.vue')
  },
  {
    path: '/homework',
    name: 'homework',
    children: [
      {
        path: '', name: 'homeworks', component: () => import(/* webpackChunkName: "about" */ '../components/homework/MyHomework.vue')
      },
      {
        path: ':homeworkTaskId/reports/:testId', name: 'homeworkTestReports', component: () => import(/* webpackChunkName: "about" */ '../components/homework/HomeworkResults.vue')
      }
    ],
  },
  {
    path: '/testseries',
    name: 'collections',
    children: [
    {
      path: ':collectionId/:type', name: 'tests', component: () => import(/* webpackChunkName: "about" */ '../components/Test/TestListPage.vue')
    },
    {
      path: ':collectionId/:type/:testId', name: 'reports', component: () => import(/* webpackChunkName: "about" */ '../components/Test/TestListPage.vue')
    },
  ],

    component: () => import(/* webpackChunkName: "about" */ '../components/Test/TestListPage.vue')
  },
  {
    path: '/starttest/:testId',
    name: 'starttest',
    component: () => import(/* webpackChunkName: "about" */ '../components/Test/StartTestPage.vue')
  },
  {
    path: '/testquestionpage',
    name: 'testquestion',
    component: () => import(/* webpackChunkName: "about" */ '../components/Test/TestQuestionPage.vue')
  },
  {
    path: '/testsubmission',
    name: 'testsubmission',
    component: () => import(/* webpackChunkName: "about" */ '../components/Test/TestSubmissionPage.vue')
  },
  {
    path: '/testresult/:testId',
    name: 'testresult',
    component: () => import(/* webpackChunkName: "about" */ '../components/Test/TestResultPage.vue')
  },
  {
    path:'/forms',
    name: 'formsList',
    component: () => import(/* webpackChunkName: "about" */ '../components/forms/FormsList.vue'),
  },
  {
    path: '/forms/:formId',
    name: 'formDetail',
    component: () => import(/* webpackChunkName: "about" */ '../components/forms/FormDetail.vue'),
    props:true
  }
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

const DEFAULT_HOME_PATH = 'learn';
router.beforeEach((to,) => {
  // console.log("from", from);
  // console.log("to", to);
  // console.log("to", store.getters.testRoutingAllowed);

  if (to.path.startsWith('/testseries')) {
    store.commit('appbarVisible', true);
    store.commit('navbarVisible', true);
  }

  if (to.path == '/testquestionpage' && !store.getters.testRoutingAllowed) {
    // console.log("sending user back to test");
    return {
      path: '/testseries',

    }


  }
  if (to.path == '/testsubmission' && !store.getters.testRoutingAllowed) {
    console.log("sending user back to test2");
    return {
      path: '/testseries',

    }
  }




  if (!to.meta.noAuthNeeded && !isUserLoggedIn()) {
    return {
      path: '/',
      // save the location we were at to come back later
      //query: { redirect: to.fullPath },
    }
  } else if (to.path === '/' && isUserLoggedIn()) {
    return {
      path: DEFAULT_HOME_PATH
    }
  }
});

//const DEFAULT_TITLE = 'MentoMind';
router.afterEach(() => {
  document.title = getAppTitle(); //DEFAULT_TITLE; //to.meta.title ;
});

export default router
